<template>
	<div class="c-card-form flex">
		<label class="c-card-form-label flex-end-center" :style="{'width': `${labelLength}em`}"><b v-if="required">*</b>{{label}}</label>
		<div class="flex-grow"><slot></slot></div>
		<div v-if="$scopedSlots.handle" class="c-card-form-handle flex-center">
			<slot name="handle"></slot>
		</div>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'detailCardForm',

		props: {
			label: String,
			required: Boolean
		},

		data() {
			return {
				...getStore(this, 'detailCardStore')
			}
		},
		
		computed: {
			...mapStore('detailCardStore', ['labelLength'])
		},

		mounted() {
			this.detailCardStore.updateLabelLength(this.label.length + (this.required ? 1 : 0));
		},

		beforeDestroy() {
			this.detailCardStore.updateLabelLength(this.label.length + (this.required ? 1 : 0), true);
		}
	}
</script>

<style lang="stylus" scoped>
	.c-card-form {
		padding: .1rem 0;

		&-label {
			margin-right: .2rem;
			height: .6rem;
			font-size: .28rem;
			color: #666;

			b {
				width: .8em;
				color: #f55;
			}
		}

		>>> .c-input,
		>>> .c-select,
		>>> .c-datetime {
			height: .6rem;
			background: #FFFAAD;
		}

		>>> .c-select-tag {
			margin-left: -.14rem;
		}

		>>> .c-file-media,
		>>> .c-upload-media-upload {
			width: 1.4rem !important;
			min-width: 1.4rem !important;
			height: 1.4rem !important;
		}

		&-handle {
			gap: .2rem;
			height: .6rem;
			margin-left: .3rem;
			color: .28rem;

			>>> .c-link[color=red] {
				color: #f55;
			}
		}
	}
</style>
